import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import axiosInstance from "../../services/axiosInstance";

const instance = axiosInstance();
export async function getSubcontractorInfo(subcontractorRequest) {
  const formattedRequest = {
    naics_code: subcontractorRequest.naics || "",
    pop_street_address: subcontractorRequest.streetAddress || "",
    pop_city: subcontractorRequest.city || "",
    pop_state: subcontractorRequest.state || "",
    pop_zip: subcontractorRequest.zip || "",
    pop_country: subcontractorRequest.country || "",
    description: subcontractorRequest.description || ""
  };
  const response = await instance.post('/contract/subcontractor-info', formattedRequest);
  return response.data;
}

export async function getSubcontractorDetails(subcontractorDetailsRequest) {
  const formattedRequest = {
    place_id: subcontractorDetailsRequest?.place_id || "",
  }
  const response = await instance.post('/contract/subcontractor-details', formattedRequest);
  return response.data;
}

export function useGetSubcontractorDetails(subcontractorDetailsRequest = {}) {
  return useQuery({
    queryKey: ["SubcontractorDetailsRequest", subcontractorDetailsRequest],
    queryFn: async () => {
      return getSubcontractorDetails(subcontractorDetailsRequest);
    },
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
  });
}
export function useSubcontractors(subcontractorRequest) {
    return useQuery({
      queryKey: ["SubcontractorRequest", subcontractorRequest],
      queryFn: async () => {
        return getSubcontractorInfo(subcontractorRequest);
      },
      onError: (e) => {
        if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
        else toast.error(e.message);
      },
    });
}